import Loading from '@/components/Loading'
import Icon from '@/components/utilities/Icon'
import Link from 'next/link'
import { useGetProductsQuery } from '../../shopify/api'

interface SearchRecommendationsProps {
  query?: string
  pdpPrefix?: string
}

const SearchRecommendations: React.FC<SearchRecommendationsProps> = ({
  query = '',
  pdpPrefix = 'product',
}) => {
  const { loading, data, error } = useGetProductsQuery({
    variables: {
      first: 5,
      query: query,
      reverse: true,
    },
  })

  if (loading) return <Loading />
  if (!data) return <div>error</div>

  return (
    <div>
      {data.products.nodes.map((node) => {
        return (
          <Link key={node.id} href={`/${pdpPrefix}/${node.handle}`}>
            <div className='flex items-center gap-2 text-sm py-[15px] px-2 cursor-pointer'>
              <Icon iconSrc='/icons/ic-search.svg' alt='search' width={13} />
              {node.title}
            </div>
          </Link>
        )
      })}
    </div>
  )
}

export default SearchRecommendations
